/**
 * Generated by orval v8.17.0 🍺
 * Do not edit manually.
 * Server, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FirefinchClientDto,
  FirefinchProjectDto,
  FirefinchRiskRegisterDto,
  FirefinchSelectOption,
  FirefinchUserStoryDto,
  GetApiNotionPhasePhaseIdUserStoriesParams,
  GetApiNotionProjectProjectIdUserStoriesParams
} from '../models';

import { customInstance } from '../../../orvalCustomAxiosInstance';
import type { ErrorType } from '../../../orvalCustomAxiosInstance';




/**
 * Get all clients from Notion.
 */
export const getApiNotionClient = (

 signal?: AbortSignal
) => {


      return customInstance<FirefinchClientDto[]>(
      {url: `/api/Notion/client`, method: 'GET', signal
    },
      );
    }




export const getGetApiNotionClientQueryKey = () => {
    return [
    `/api/Notion/client`
    ] as const;
    }


export const getGetApiNotionClientQueryOptions = <TData = Awaited<ReturnType<typeof getApiNotionClient>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionClient>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiNotionClientQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiNotionClient>>> = ({ signal }) => getApiNotionClient(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiNotionClient>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiNotionClientQueryResult = NonNullable<Awaited<ReturnType<typeof getApiNotionClient>>>
export type GetApiNotionClientQueryError = ErrorType<unknown>


export function useGetApiNotionClient<TData = Awaited<ReturnType<typeof getApiNotionClient>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionClient>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotionClient>>,
          TError,
          Awaited<ReturnType<typeof getApiNotionClient>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiNotionClient<TData = Awaited<ReturnType<typeof getApiNotionClient>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionClient>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotionClient>>,
          TError,
          Awaited<ReturnType<typeof getApiNotionClient>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiNotionClient<TData = Awaited<ReturnType<typeof getApiNotionClient>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionClient>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiNotionClient<TData = Awaited<ReturnType<typeof getApiNotionClient>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionClient>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiNotionClientQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Get all projects across all clients from Notion, filtered by allowed project types.
 */
export const getApiNotionProject = (

 signal?: AbortSignal
) => {


      return customInstance<FirefinchProjectDto[]>(
      {url: `/api/Notion/project`, method: 'GET', signal
    },
      );
    }




export const getGetApiNotionProjectQueryKey = () => {
    return [
    `/api/Notion/project`
    ] as const;
    }


export const getGetApiNotionProjectQueryOptions = <TData = Awaited<ReturnType<typeof getApiNotionProject>>, TError = ErrorType<unknown>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProject>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiNotionProjectQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiNotionProject>>> = ({ signal }) => getApiNotionProject(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiNotionProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getApiNotionProject>>>
export type GetApiNotionProjectQueryError = ErrorType<unknown>


export function useGetApiNotionProject<TData = Awaited<ReturnType<typeof getApiNotionProject>>, TError = ErrorType<unknown>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProject>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotionProject>>,
          TError,
          Awaited<ReturnType<typeof getApiNotionProject>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiNotionProject<TData = Awaited<ReturnType<typeof getApiNotionProject>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProject>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotionProject>>,
          TError,
          Awaited<ReturnType<typeof getApiNotionProject>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiNotionProject<TData = Awaited<ReturnType<typeof getApiNotionProject>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProject>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiNotionProject<TData = Awaited<ReturnType<typeof getApiNotionProject>>, TError = ErrorType<unknown>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProject>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiNotionProjectQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Get all projects for a client from Notion.
 */
export const getApiNotionClientClientIdProject = (
    clientId: string,
 signal?: AbortSignal
) => {


      return customInstance<FirefinchProjectDto[]>(
      {url: `/api/Notion/client/${clientId}/project`, method: 'GET', signal
    },
      );
    }




export const getGetApiNotionClientClientIdProjectQueryKey = (clientId: string,) => {
    return [
    `/api/Notion/client/${clientId}/project`
    ] as const;
    }


export const getGetApiNotionClientClientIdProjectQueryOptions = <TData = Awaited<ReturnType<typeof getApiNotionClientClientIdProject>>, TError = ErrorType<unknown>>(clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionClientClientIdProject>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiNotionClientClientIdProjectQueryKey(clientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiNotionClientClientIdProject>>> = ({ signal }) => getApiNotionClientClientIdProject(clientId, signal);





   return  { queryKey, queryFn, enabled: clientId !== null && clientId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiNotionClientClientIdProject>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiNotionClientClientIdProjectQueryResult = NonNullable<Awaited<ReturnType<typeof getApiNotionClientClientIdProject>>>
export type GetApiNotionClientClientIdProjectQueryError = ErrorType<unknown>


export function useGetApiNotionClientClientIdProject<TData = Awaited<ReturnType<typeof getApiNotionClientClientIdProject>>, TError = ErrorType<unknown>>(
 clientId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionClientClientIdProject>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotionClientClientIdProject>>,
          TError,
          Awaited<ReturnType<typeof getApiNotionClientClientIdProject>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiNotionClientClientIdProject<TData = Awaited<ReturnType<typeof getApiNotionClientClientIdProject>>, TError = ErrorType<unknown>>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionClientClientIdProject>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotionClientClientIdProject>>,
          TError,
          Awaited<ReturnType<typeof getApiNotionClientClientIdProject>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiNotionClientClientIdProject<TData = Awaited<ReturnType<typeof getApiNotionClientClientIdProject>>, TError = ErrorType<unknown>>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionClientClientIdProject>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiNotionClientClientIdProject<TData = Awaited<ReturnType<typeof getApiNotionClientClientIdProject>>, TError = ErrorType<unknown>>(
 clientId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionClientClientIdProject>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiNotionClientClientIdProjectQueryOptions(clientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Get a projects risk register database from Notion.
 */
export const getApiNotionProjectProjectIdRisks = (
    projectId: string,
 signal?: AbortSignal
) => {


      return customInstance<FirefinchRiskRegisterDto[]>(
      {url: `/api/Notion/project/${projectId}/risks`, method: 'GET', signal
    },
      );
    }




export const getGetApiNotionProjectProjectIdRisksQueryKey = (projectId: string,) => {
    return [
    `/api/Notion/project/${projectId}/risks`
    ] as const;
    }


export const getGetApiNotionProjectProjectIdRisksQueryOptions = <TData = Awaited<ReturnType<typeof getApiNotionProjectProjectIdRisks>>, TError = ErrorType<unknown>>(projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProjectProjectIdRisks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiNotionProjectProjectIdRisksQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiNotionProjectProjectIdRisks>>> = ({ signal }) => getApiNotionProjectProjectIdRisks(projectId, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProjectProjectIdRisks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiNotionProjectProjectIdRisksQueryResult = NonNullable<Awaited<ReturnType<typeof getApiNotionProjectProjectIdRisks>>>
export type GetApiNotionProjectProjectIdRisksQueryError = ErrorType<unknown>


export function useGetApiNotionProjectProjectIdRisks<TData = Awaited<ReturnType<typeof getApiNotionProjectProjectIdRisks>>, TError = ErrorType<unknown>>(
 projectId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProjectProjectIdRisks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotionProjectProjectIdRisks>>,
          TError,
          Awaited<ReturnType<typeof getApiNotionProjectProjectIdRisks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiNotionProjectProjectIdRisks<TData = Awaited<ReturnType<typeof getApiNotionProjectProjectIdRisks>>, TError = ErrorType<unknown>>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProjectProjectIdRisks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotionProjectProjectIdRisks>>,
          TError,
          Awaited<ReturnType<typeof getApiNotionProjectProjectIdRisks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiNotionProjectProjectIdRisks<TData = Awaited<ReturnType<typeof getApiNotionProjectProjectIdRisks>>, TError = ErrorType<unknown>>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProjectProjectIdRisks>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiNotionProjectProjectIdRisks<TData = Awaited<ReturnType<typeof getApiNotionProjectProjectIdRisks>>, TError = ErrorType<unknown>>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProjectProjectIdRisks>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiNotionProjectProjectIdRisksQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Get a projects user stories database from Notion.
 */
export const getApiNotionProjectProjectIdUserStories = (
    projectId: string,
    params?: GetApiNotionProjectProjectIdUserStoriesParams,
 signal?: AbortSignal
) => {


      return customInstance<FirefinchUserStoryDto[]>(
      {url: `/api/Notion/project/${projectId}/user-stories`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiNotionProjectProjectIdUserStoriesQueryKey = (projectId: string,
    params?: GetApiNotionProjectProjectIdUserStoriesParams,) => {
    return [
    `/api/Notion/project/${projectId}/user-stories`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiNotionProjectProjectIdUserStoriesQueryOptions = <TData = Awaited<ReturnType<typeof getApiNotionProjectProjectIdUserStories>>, TError = ErrorType<unknown>>(projectId: string,
    params?: GetApiNotionProjectProjectIdUserStoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProjectProjectIdUserStories>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiNotionProjectProjectIdUserStoriesQueryKey(projectId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiNotionProjectProjectIdUserStories>>> = ({ signal }) => getApiNotionProjectProjectIdUserStories(projectId,params, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProjectProjectIdUserStories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiNotionProjectProjectIdUserStoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiNotionProjectProjectIdUserStories>>>
export type GetApiNotionProjectProjectIdUserStoriesQueryError = ErrorType<unknown>


export function useGetApiNotionProjectProjectIdUserStories<TData = Awaited<ReturnType<typeof getApiNotionProjectProjectIdUserStories>>, TError = ErrorType<unknown>>(
 projectId: string,
    params: undefined |  GetApiNotionProjectProjectIdUserStoriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProjectProjectIdUserStories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotionProjectProjectIdUserStories>>,
          TError,
          Awaited<ReturnType<typeof getApiNotionProjectProjectIdUserStories>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiNotionProjectProjectIdUserStories<TData = Awaited<ReturnType<typeof getApiNotionProjectProjectIdUserStories>>, TError = ErrorType<unknown>>(
 projectId: string,
    params?: GetApiNotionProjectProjectIdUserStoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProjectProjectIdUserStories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotionProjectProjectIdUserStories>>,
          TError,
          Awaited<ReturnType<typeof getApiNotionProjectProjectIdUserStories>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiNotionProjectProjectIdUserStories<TData = Awaited<ReturnType<typeof getApiNotionProjectProjectIdUserStories>>, TError = ErrorType<unknown>>(
 projectId: string,
    params?: GetApiNotionProjectProjectIdUserStoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProjectProjectIdUserStories>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiNotionProjectProjectIdUserStories<TData = Awaited<ReturnType<typeof getApiNotionProjectProjectIdUserStories>>, TError = ErrorType<unknown>>(
 projectId: string,
    params?: GetApiNotionProjectProjectIdUserStoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProjectProjectIdUserStories>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiNotionProjectProjectIdUserStoriesQueryOptions(projectId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Get project phases (subprojects) from Notion.
 */
export const getApiNotionProjectProjectIdPhases = (
    projectId: string,
 signal?: AbortSignal
) => {


      return customInstance<FirefinchSelectOption[]>(
      {url: `/api/Notion/project/${projectId}/phases`, method: 'GET', signal
    },
      );
    }




export const getGetApiNotionProjectProjectIdPhasesQueryKey = (projectId: string,) => {
    return [
    `/api/Notion/project/${projectId}/phases`
    ] as const;
    }


export const getGetApiNotionProjectProjectIdPhasesQueryOptions = <TData = Awaited<ReturnType<typeof getApiNotionProjectProjectIdPhases>>, TError = ErrorType<unknown>>(projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProjectProjectIdPhases>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiNotionProjectProjectIdPhasesQueryKey(projectId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiNotionProjectProjectIdPhases>>> = ({ signal }) => getApiNotionProjectProjectIdPhases(projectId, signal);





   return  { queryKey, queryFn, enabled: projectId !== null && projectId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProjectProjectIdPhases>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiNotionProjectProjectIdPhasesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiNotionProjectProjectIdPhases>>>
export type GetApiNotionProjectProjectIdPhasesQueryError = ErrorType<unknown>


export function useGetApiNotionProjectProjectIdPhases<TData = Awaited<ReturnType<typeof getApiNotionProjectProjectIdPhases>>, TError = ErrorType<unknown>>(
 projectId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProjectProjectIdPhases>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotionProjectProjectIdPhases>>,
          TError,
          Awaited<ReturnType<typeof getApiNotionProjectProjectIdPhases>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiNotionProjectProjectIdPhases<TData = Awaited<ReturnType<typeof getApiNotionProjectProjectIdPhases>>, TError = ErrorType<unknown>>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProjectProjectIdPhases>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotionProjectProjectIdPhases>>,
          TError,
          Awaited<ReturnType<typeof getApiNotionProjectProjectIdPhases>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiNotionProjectProjectIdPhases<TData = Awaited<ReturnType<typeof getApiNotionProjectProjectIdPhases>>, TError = ErrorType<unknown>>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProjectProjectIdPhases>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiNotionProjectProjectIdPhases<TData = Awaited<ReturnType<typeof getApiNotionProjectProjectIdPhases>>, TError = ErrorType<unknown>>(
 projectId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionProjectProjectIdPhases>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiNotionProjectProjectIdPhasesQueryOptions(projectId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Get a phase's risk register database from Notion.
 */
export const getApiNotionPhasePhaseIdRisks = (
    phaseId: string,
 signal?: AbortSignal
) => {


      return customInstance<FirefinchRiskRegisterDto[]>(
      {url: `/api/Notion/phase/${phaseId}/risks`, method: 'GET', signal
    },
      );
    }




export const getGetApiNotionPhasePhaseIdRisksQueryKey = (phaseId: string,) => {
    return [
    `/api/Notion/phase/${phaseId}/risks`
    ] as const;
    }


export const getGetApiNotionPhasePhaseIdRisksQueryOptions = <TData = Awaited<ReturnType<typeof getApiNotionPhasePhaseIdRisks>>, TError = ErrorType<unknown>>(phaseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionPhasePhaseIdRisks>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiNotionPhasePhaseIdRisksQueryKey(phaseId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiNotionPhasePhaseIdRisks>>> = ({ signal }) => getApiNotionPhasePhaseIdRisks(phaseId, signal);





   return  { queryKey, queryFn, enabled: phaseId !== null && phaseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiNotionPhasePhaseIdRisks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiNotionPhasePhaseIdRisksQueryResult = NonNullable<Awaited<ReturnType<typeof getApiNotionPhasePhaseIdRisks>>>
export type GetApiNotionPhasePhaseIdRisksQueryError = ErrorType<unknown>


export function useGetApiNotionPhasePhaseIdRisks<TData = Awaited<ReturnType<typeof getApiNotionPhasePhaseIdRisks>>, TError = ErrorType<unknown>>(
 phaseId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionPhasePhaseIdRisks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotionPhasePhaseIdRisks>>,
          TError,
          Awaited<ReturnType<typeof getApiNotionPhasePhaseIdRisks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiNotionPhasePhaseIdRisks<TData = Awaited<ReturnType<typeof getApiNotionPhasePhaseIdRisks>>, TError = ErrorType<unknown>>(
 phaseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionPhasePhaseIdRisks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotionPhasePhaseIdRisks>>,
          TError,
          Awaited<ReturnType<typeof getApiNotionPhasePhaseIdRisks>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiNotionPhasePhaseIdRisks<TData = Awaited<ReturnType<typeof getApiNotionPhasePhaseIdRisks>>, TError = ErrorType<unknown>>(
 phaseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionPhasePhaseIdRisks>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiNotionPhasePhaseIdRisks<TData = Awaited<ReturnType<typeof getApiNotionPhasePhaseIdRisks>>, TError = ErrorType<unknown>>(
 phaseId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionPhasePhaseIdRisks>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiNotionPhasePhaseIdRisksQueryOptions(phaseId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






/**
 * Get a phase's user stories database from Notion.
 */
export const getApiNotionPhasePhaseIdUserStories = (
    phaseId: string,
    params?: GetApiNotionPhasePhaseIdUserStoriesParams,
 signal?: AbortSignal
) => {


      return customInstance<FirefinchUserStoryDto[]>(
      {url: `/api/Notion/phase/${phaseId}/user-stories`, method: 'GET',
        params, signal
    },
      );
    }




export const getGetApiNotionPhasePhaseIdUserStoriesQueryKey = (phaseId: string,
    params?: GetApiNotionPhasePhaseIdUserStoriesParams,) => {
    return [
    `/api/Notion/phase/${phaseId}/user-stories`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetApiNotionPhasePhaseIdUserStoriesQueryOptions = <TData = Awaited<ReturnType<typeof getApiNotionPhasePhaseIdUserStories>>, TError = ErrorType<unknown>>(phaseId: string,
    params?: GetApiNotionPhasePhaseIdUserStoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionPhasePhaseIdUserStories>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiNotionPhasePhaseIdUserStoriesQueryKey(phaseId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiNotionPhasePhaseIdUserStories>>> = ({ signal }) => getApiNotionPhasePhaseIdUserStories(phaseId,params, signal);





   return  { queryKey, queryFn, enabled: phaseId !== null && phaseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiNotionPhasePhaseIdUserStories>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiNotionPhasePhaseIdUserStoriesQueryResult = NonNullable<Awaited<ReturnType<typeof getApiNotionPhasePhaseIdUserStories>>>
export type GetApiNotionPhasePhaseIdUserStoriesQueryError = ErrorType<unknown>


export function useGetApiNotionPhasePhaseIdUserStories<TData = Awaited<ReturnType<typeof getApiNotionPhasePhaseIdUserStories>>, TError = ErrorType<unknown>>(
 phaseId: string,
    params: undefined |  GetApiNotionPhasePhaseIdUserStoriesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionPhasePhaseIdUserStories>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotionPhasePhaseIdUserStories>>,
          TError,
          Awaited<ReturnType<typeof getApiNotionPhasePhaseIdUserStories>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiNotionPhasePhaseIdUserStories<TData = Awaited<ReturnType<typeof getApiNotionPhasePhaseIdUserStories>>, TError = ErrorType<unknown>>(
 phaseId: string,
    params?: GetApiNotionPhasePhaseIdUserStoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionPhasePhaseIdUserStories>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiNotionPhasePhaseIdUserStories>>,
          TError,
          Awaited<ReturnType<typeof getApiNotionPhasePhaseIdUserStories>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiNotionPhasePhaseIdUserStories<TData = Awaited<ReturnType<typeof getApiNotionPhasePhaseIdUserStories>>, TError = ErrorType<unknown>>(
 phaseId: string,
    params?: GetApiNotionPhasePhaseIdUserStoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionPhasePhaseIdUserStories>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiNotionPhasePhaseIdUserStories<TData = Awaited<ReturnType<typeof getApiNotionPhasePhaseIdUserStories>>, TError = ErrorType<unknown>>(
 phaseId: string,
    params?: GetApiNotionPhasePhaseIdUserStoriesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiNotionPhasePhaseIdUserStories>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiNotionPhasePhaseIdUserStoriesQueryOptions(phaseId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






